/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import {
    call, put, select,
} from 'redux-saga/effects';
import mbpLogger from 'mbp-logger';

import { getMostUsedPaymentMethods } from '../../../../../../../apis/person-apis/getMostUsedPaymentMethods';
import { checkJWT } from '../../../../../Checkout/ducks/Global/Global-Operations';
import { getIsAuthenticatedStatus, getUserType } from '../../../../../Member/ducks/Common/Common-Selectors';
import { loadMostUsedPaymentMethods, selectPersonalizedPaymentMethod } from './UserPaymentMethod-Actions';
import { getFeatureFlag } from '../../../../../App/ducks/Config/Config-Selectors';
import { isPersonlaizedPaymentMethodSelected } from './UserPaymentMethod-Selectors';
import { setPaymentMethod } from '../../../../../Checkout/ducks/Payment/ducks/PaymentForm/PaymentForm-Actions';

export function* fetchMostUsedPaymentMethods() {
    try {
        const personalizedPaymentSelected = yield select(isPersonlaizedPaymentMethodSelected);
        if (personalizedPaymentSelected) {
            // reset default payment method if it is updated previously by reorder api
            yield put(setPaymentMethod({ id: 'CreditCard', name: 'CreditCard' }));
            yield put(selectPersonalizedPaymentMethod(false));
        }
        const isReorderFlagEnabled = yield select(getFeatureFlag('is-reorder-payment-methods-enabled'));

        if (isReorderFlagEnabled) {
            const JWT_TOKEN = yield call(checkJWT);
            const isAuthenticated = yield select(getIsAuthenticatedStatus);
            const userType = yield select(getUserType);
            if (JWT_TOKEN && isAuthenticated && userType !== 'G') {
                const response = yield call(getMostUsedPaymentMethods, JWT_TOKEN);
                const mostUsedMethods = (response?.data || []).map((ele) => ele?.paymentMethod || '');
                yield put(loadMostUsedPaymentMethods(mostUsedMethods));
            } else {
                yield put(loadMostUsedPaymentMethods([]));
            }
        }
    } catch (ex) {
        mbpLogger.logError({
            function: 'fetchMostUsedPaymentMethods',
            appName: process.env.npm_package_name,
            module: 'UserPaymentMethod-Operations.js',
            message: 'Failed - fetchMostUsedPaymentMethods',
            jsError: ex,
        });
    }
}

export default { fetchMostUsedPaymentMethods };
